import { s } from './icon.style'
import React from 'react'
import type { IconProps } from '../iconProps'

export const CorrectIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.9999 2.65002C6.8296 2.65002 2.6499 6.82972 2.6499 12C2.6499 17.1703 6.8296 21.35 11.9999 21.35C17.1702 21.35 21.3499 17.1703 21.3499 12C21.3499 6.82972 17.1702 2.65002 11.9999 2.65002ZM5.1499 12C5.1499 8.22432 8.2242 5.15002 11.9999 5.15002C15.7756 5.15002 18.8499 8.22432 18.8499 12C18.8499 15.7757 15.7756 18.85 11.9999 18.85C8.2242 18.85 5.1499 15.7757 5.1499 12Z"
          fill="#00ABFF"
        />
      </svg>
    )
  }
)
